import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { ContactUsHeadphones } from 'Images';

export const SubmissionReview = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status);
  return (
    <Stack>
      <Typography variant='body6'>{dictionary.steps.step1.info1}</Typography>
      <Typography variant='body6'>{dictionary.steps.step1.info2}</Typography>
      <Typography variant='body6' sx={{ m: '20px 0' }}>
        {dictionary.steps.step1.info3}
      </Typography>
      <Typography variant='body6' sx={{ mb: '32px' }}>
        <strong>{dictionary.steps.step1.info4[0]}</strong>
        {dictionary.steps.step1.info4[1]}
      </Typography>
      <Stack direction='row' alignItems='center' gap='10px'>
        <Avatar
          alt=''
          src={ContactUsHeadphones}
          sx={{ width: '32px', height: '32px' }}
        />
        <Typography variant='body6'>{dictionary.steps.step1.info5}</Typography>
      </Stack>
    </Stack>
  );
};
